module.exports = __webpack_public_path__ + "img/telemedecine2.0076720d.jpg";